import Dialog from '@mui/material/Dialog';
import Fade from '@mui/material/Fade';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import './agent-ready-modal.scss';
import { GIFS } from '../../assets';
import { ZoButton } from '@zonofi/zo-components/input/zo-button/zo-button';
import { getWorkspace, useAppSelector } from '@zonofi/seller-rtk-store';

const FadeTransition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Fade ref={ref} {...props} timeout={500} />;
});

export const AgentReadyModal: React.FC<{
  onClose: () => void;
  open: boolean;
}> = ({ onClose, open }) => {
  const workspace = useAppSelector(getWorkspace);
  return (
    <Dialog
      open={open}
      TransitionComponent={FadeTransition}
      PaperProps={{
        sx: {
          borderRadius: '32px',
        },
      }}
    >
      <div className="agent-ready-modal">
        <div className="agent-ready-modal-gif">
          <img src={GIFS.ExcitedRobot} alt="" width={120} height={120} />
        </div>
        <div className="agent-ready-modal-content">
          <span className="agent-ready-modal-content-heading primary-font-bold">
            Meet Your {workspace?.spaceName} Test AI Business Assistant!
          </span>
          <span className="agent-ready-modal-content-description primary-font-regular">
            Ask the Agent about products, pricing, or distributors, schemes and
            get customised answers instantly!
          </span>
        </div>
        <ZoButton
          onClick={onClose}
          label={'Test AI Agent'}
          className="agent-ready-modal-btn"
        />
      </div>
    </Dialog>
  );
};
